import BaseService from "./BaseService";
import http from './HttpService';
import { API_BASE_URL_ENV } from "../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/loans";

export default class LoanService extends BaseService {
  constructor() {
    super(apiEndpoint);
  }

  approve(id, data) {
    return http.post(`${apiEndpoint}/${id}/approve`, data);
  }

  pay(id) {
    return http.post(`${apiEndpoint}/${id}/pay`);
  }
}
